import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "components.formExpired.";

export const FormExpired = memo(() => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <img
        src="/form-not-found.png"
        alt="Form expired"
        style={{ height: 250 }}
      />
      <Typography fontWeight="bold" variant="h5" textAlign="center">
        {t(translationPath + "message")}
      </Typography>
    </Box>
  );
});
